module.exports = __webpack_public_path__ + "img/og-image.d4b8b098.png";